import { useState } from "react";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const monthlyRevenue = [182000, 210000, 195000, 240000, 315000, 290000, 260000, 305000, 275000, 330000, 410000, 385000];
const monthlyOrders  = [38, 44, 41, 52, 68, 61, 55, 64, 58, 72, 91, 84];

const topProducts = [
  { name: "Diamond Solitaire Ring",  revenue: 285000, units: 32, pct: 88 },
  { name: "Gold Jhumka Earrings",    revenue: 198000, units: 71, pct: 61 },
  { name: "Ruby Necklace Set",       revenue: 175000, units: 24, pct: 54 },
  { name: "Emerald Bangles (Pair)",  revenue: 142000, units: 40, pct: 44 },
  { name: "Silver Anklet",           revenue: 89000,  units: 95, pct: 28 },
];

const paymentMix = [
  { method: "UPI",         pct: 42, color: "#059669" },
  { method: "Card",        pct: 31, color: "#2563eb" },
  { method: "Net Banking", pct: 16, color: "#0891b2" },
  { method: "COD",         pct:  7, color: "#d97706" },
  { method: "Wallet",      pct:  4, color: "#7c3aed" },
];

const STYLES = `
  .rp-grid { display:grid; grid-template-columns:repeat(auto-fit,minmax(140px,1fr)); gap:14px; }
  .rp-kpi { background:#fff; border:1px solid #f0ebe4; border-radius:16px; padding:18px 20px; box-shadow:0 2px 8px rgba(26,18,8,.06); }
  .rp-kpi-lbl { font-size:11px; font-weight:700; color:#9b8878; text-transform:uppercase; letter-spacing:.6px; margin-bottom:6px; display:flex; align-items:center; gap:6px; }
  .rp-kpi-val { font-size:22px; font-weight:800; color:#1a1208; }
  .rp-kpi-delta { font-size:11px; margin-top:3px; font-weight:600; }
  .rp-kpi-delta.up { color:#16a34a; }
  .rp-kpi-delta.dn { color:#dc2626; }

  .rp-card { background:#fff; border:1px solid #f0ebe4; border-radius:16px; box-shadow:0 2px 12px rgba(26,18,8,.07); overflow:hidden; }
  .rp-card-head { display:flex; align-items:center; justify-content:space-between; padding:14px 20px; border-bottom:1.5px solid #f5f0eb; background:linear-gradient(135deg,#1a1208 0%,#2d1e0f 100%); }
  .rp-card-title { font-size:14px; font-weight:800; color:#fff; display:flex; align-items:center; gap:8px; }
  .rp-range-btn { padding:4px 12px; border-radius:20px; border:1.5px solid rgba(255,255,255,.15); background:transparent; color:rgba(255,255,255,.6); font-size:11px; font-weight:700; cursor:pointer; font-family:inherit; transition:all .15s; }
  .rp-range-btn.active { background:rgba(255,255,255,.12); color:#fff; border-color:rgba(255,255,255,.3); }
  .rp-card-body { padding:20px; }

  /* Bar chart */
  .rp-chart-wrap { display:flex; align-items:flex-end; gap:6px; height:160px; padding-bottom:24px; position:relative; }
  .rp-bar-col { display:flex; flex-direction:column; align-items:center; flex:1; gap:4px; height:100%; justify-content:flex-end; }
  .rp-bar { border-radius:6px 6px 0 0; width:100%; background:linear-gradient(180deg,var(--theme),#e05a28); transition:height .5s cubic-bezier(.34,1.56,.64,1); cursor:pointer; position:relative; }
  .rp-bar:hover::after { content:attr(data-tip); position:absolute; top:-32px; left:50%; transform:translateX(-50%); background:#1a1208; color:#fff; font-size:10px; font-weight:700; padding:3px 8px; border-radius:6px; white-space:nowrap; pointer-events:none; }
  .rp-bar-lbl { font-size:10px; color:#9b8878; font-weight:600; }

  /* Top Products */
  .rp-prod-row { display:flex; align-items:center; gap:12px; padding:10px 0; border-bottom:1px solid #f5f0eb; }
  .rp-prod-row:last-child { border-bottom:none; }
  .rp-prod-rank { width:24px; height:24px; border-radius:8px; background:linear-gradient(135deg,#1a1208,#2d1e0f); color:#f5c89a; font-size:11px; font-weight:800; display:flex; align-items:center; justify-content:center; flex-shrink:0; }
  .rp-prod-name { flex:1; font-size:13px; font-weight:600; color:#1a1208; }
  .rp-prod-bar-wrap { width:100px; background:#f0ebe4; border-radius:4px; height:6px; overflow:hidden; }
  .rp-prod-bar { height:100%; border-radius:4px; background:linear-gradient(90deg,var(--theme),#e05a28); }
  .rp-prod-rev { font-size:12px; font-weight:700; color:var(--theme); white-space:nowrap; }

  /* Payment mix */
  .rp-mix-row { display:flex; align-items:center; gap:10px; margin-bottom:12px; }
  .rp-mix-dot { width:10px; height:10px; border-radius:50%; flex-shrink:0; }
  .rp-mix-label { flex:1; font-size:13px; font-weight:600; color:#1a1208; }
  .rp-mix-bar-wrap { width:120px; background:#f0ebe4; border-radius:4px; height:6px; overflow:hidden; }
  .rp-mix-bar { height:100%; border-radius:4px; }
  .rp-mix-pct { font-size:12px; font-weight:700; color:#7a6652; width:28px; text-align:right; }

  .rp-two-col { display:grid; grid-template-columns:1fr 1fr; gap:14px; }
  @media(max-width:700px) { .rp-two-col { grid-template-columns:1fr; } }

  .rp-range-row { display:flex; gap:6px; }
  .rp-export-btn { padding:5px 14px; border-radius:20px; border:1.5px solid rgba(255,255,255,.2); background:rgba(255,255,255,.08); color:#f5c89a; font-size:11px; font-weight:700; cursor:pointer; font-family:inherit; display:flex; align-items:center; gap:5px; }
`;

export function ReportsPage() {
  const [range, setRange] = useState<"3M" | "6M" | "12M">("12M");

  const sliceLen = range === "3M" ? 3 : range === "6M" ? 6 : 12;
  const revSlice = monthlyRevenue.slice(-sliceLen);
  const ordSlice = monthlyOrders.slice(-sliceLen);
  const lblSlice = MONTHS.slice(-sliceLen);
  const maxRev   = Math.max(...revSlice);

  const totalRevenue = revSlice.reduce((a, b) => a + b, 0);
  const totalOrders  = ordSlice.reduce((a, b) => a + b, 0);
  const avgOrder     = Math.round(totalRevenue / totalOrders);

  return (
    <div className="d-grid gap-3">
      <style>{STYLES}</style>

      {/* KPI row */}
      <div className="rp-grid">
        {[
          { lbl: "Total Revenue", val: `₹${(totalRevenue/100000).toFixed(1)}L`, delta: "+18.4%", up: true, icon: "bi-currency-rupee" },
          { lbl: "Total Orders",  val: totalOrders,                              delta: "+12.1%", up: true, icon: "bi-bag-check" },
          { lbl: "Avg Order Value",val: `₹${avgOrder.toLocaleString("en-IN")}`, delta: "+5.7%",  up: true, icon: "bi-graph-up" },
          { lbl: "Refund Rate",   val: "2.3%",                                  delta: "-0.4%",  up: false, icon: "bi-arrow-counterclockwise" },
        ].map(k => (
          <div key={k.lbl} className="rp-kpi">
            <div className="rp-kpi-lbl"><i className={`bi ${k.icon}`} style={{ color: "var(--theme)" }}></i>{k.lbl}</div>
            <div className="rp-kpi-val">{k.val}</div>
            <div className={`rp-kpi-delta ${k.up ? "up" : "dn"}`}>
              <i className={`bi ${k.up ? "bi-arrow-up-right" : "bi-arrow-down-right"}`}></i> {k.delta} vs prev period
            </div>
          </div>
        ))}
      </div>

      {/* Revenue Bar Chart */}
      <div className="rp-card">
        <div className="rp-card-head">
          <div className="rp-card-title"><i className="bi bi-bar-chart-fill"></i> Monthly Revenue</div>
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <div className="rp-range-row">
              {(["3M", "6M", "12M"] as const).map(r => (
                <button key={r} className={`rp-range-btn ${range === r ? "active" : ""}`} onClick={() => setRange(r)}>{r}</button>
              ))}
            </div>
            <button className="rp-export-btn"><i className="bi bi-download"></i> Export</button>
          </div>
        </div>
        <div className="rp-card-body">
          <div className="rp-chart-wrap">
            {revSlice.map((v, i) => (
              <div key={i} className="rp-bar-col">
                <div
                  className="rp-bar"
                  style={{ height: `${(v / maxRev) * 100}%` }}
                  data-tip={`₹${(v/1000).toFixed(0)}K`}
                ></div>
                <div className="rp-bar-lbl">{lblSlice[i]}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="rp-two-col">
        {/* Top Products */}
        <div className="rp-card">
          <div className="rp-card-head">
            <div className="rp-card-title"><i className="bi bi-trophy-fill"></i> Top Products</div>
          </div>
          <div className="rp-card-body">
            {topProducts.map((p, i) => (
              <div key={p.name} className="rp-prod-row">
                <div className="rp-prod-rank">#{i + 1}</div>
                <div style={{ flex: 1 }}>
                  <div className="rp-prod-name">{p.name}</div>
                  <div style={{ fontSize: 11, color: "#9b8878", marginTop: 2 }}>{p.units} units sold</div>
                </div>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 5 }}>
                  <div className="rp-prod-rev">₹{(p.revenue/1000).toFixed(0)}K</div>
                  <div className="rp-prod-bar-wrap"><div className="rp-prod-bar" style={{ width: `${p.pct}%` }}></div></div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Payment Mix */}
        <div className="rp-card">
          <div className="rp-card-head">
            <div className="rp-card-title"><i className="bi bi-pie-chart-fill"></i> Payment Methods</div>
          </div>
          <div className="rp-card-body">
            {/* Pseudo donut */}
            <div style={{ display: "flex", justifyContent: "center", margin: "8px 0 20px" }}>
              <div style={{ position: "relative", width: 120, height: 120 }}>
                <svg viewBox="0 0 36 36" style={{ width: 120, height: 120, transform: "rotate(-90deg)" }}>
                  {(() => {
                    let offset = 0;
                    return paymentMix.map(m => {
                      const el = (
                        <circle key={m.method} cx="18" cy="18" r="15.9"
                          fill="none" stroke={m.color} strokeWidth="3.5"
                          strokeDasharray={`${m.pct} ${100 - m.pct}`}
                          strokeDashoffset={-offset}
                        />
                      );
                      offset += m.pct;
                      return el;
                    });
                  })()}
                </svg>
                <div style={{ position: "absolute", inset: 0, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                  <div style={{ fontSize: 18, fontWeight: 800, color: "#1a1208" }}>100%</div>
                  <div style={{ fontSize: 10, color: "#9b8878" }}>mix</div>
                </div>
              </div>
            </div>
            {paymentMix.map(m => (
              <div key={m.method} className="rp-mix-row">
                <div className="rp-mix-dot" style={{ background: m.color }}></div>
                <div className="rp-mix-label">{m.method}</div>
                <div className="rp-mix-bar-wrap"><div className="rp-mix-bar" style={{ width: `${m.pct}%`, background: m.color }}></div></div>
                <div className="rp-mix-pct">{m.pct}%</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
